/**
 * Document titles for the app surface.
 *
 * Format is `Page — Planno`: the page name leads because browser tabs
 * truncate from the right, and a row of tabs all reading "Planno — …" tells
 * you nothing. The marketing pages spell their own titles out in full and do
 * not use this.
 */

export const BRAND = 'Planno'

/** `Tasks — Planno`. */
export const pageTitle = (page: string): string => `${page} — ${BRAND}`

/**
 * The title the server sends before the browser has told us anything.
 *
 * Deliberately Portuguese: `DEFAULT_LOCALE` is pt-BR, so this is right for
 * most visitors, and `localeScript` in `__root.tsx` corrects it before
 * first paint for everyone else. Kept in sync with `FALLBACK_TITLES` below —
 * this must equal the pt-BR entry.
 */
export const DEFAULT_DOCUMENT_TITLE = 'Planno — gestão para arquitetura e engenharia'

export const DEFAULT_DOCUMENT_DESCRIPTION =
  'Sistema de gestão de projetos para escritórios de arquitetura e engenharia.'

/**
 * Fallback titles by locale, inlined into the blocking head script.
 *
 * They live here rather than in the message catalogs because the script runs
 * before any JavaScript module has loaded — it cannot call `i18n._()`. Both
 * strings therefore have to be literals the script can carry.
 */
export const FALLBACK_TITLES: Record<'pt-BR' | 'en', string> = {
  en: 'Planno — project management for architects',
  'pt-BR': DEFAULT_DOCUMENT_TITLE,
}
